export default function SmallBox({text, value, bgColorClass, icon}){



    return (

        <div className={["small-box", bgColorClass].join(" ")}>
            <div className="inner">
                <h4>{value}</h4>

                <p>{text}</p>
            </div>
            <div className="icon">
                <i className={icon}></i>
            </div>
        </div>
    );


}